// extracted by mini-css-extract-plugin
module.exports = {"articleTitle":"Title_articleTitle__EYHH0","licensedArticle":"Title_licensedArticle__5GrC_","longform":"Title_longform__K94Jx","explaining":"Title_explaining__6IC4v"};